import { PATHS } from "~/const/paths";

export const LINKS = [
  {
    href: "https://dmm-corp.com/company/",
    text: "会社概要",
    target: "_blank",
  },
  {
    href: "https://terms.dmm.com/member/",
    text: "会員規約",
    target: "_blank",
  },
  {
    href: "https://terms.dmm.com/dmmtv/",
    text: "DMM TV規約",
    target: "_blank",
  },
  {
    href: "https://terms.dmm.com/privacy/",
    text: "個人情報保護に関して",
    target: "_blank",
  },
  {
    href: "https://terms.dmm.com/commerce_premium/",
    text: "特定商取引法に基づく表示（DMMプレミアム）",
    target: "_blank",
  },
  {
    href: "https://terms.dmm.com/commerce_dmmtv/",
    text: "特定商取引法に基づく表示（DMM TV）",
    target: "_blank",
  },
  {
    href: "https://dmm-corp.com/recruit/",
    text: "採用情報",
    target: "_blank",
  },
  {
    href: PATHS.COPYRIGHT,
    text: "作品コピーライト",
    target: "_self",
  },
] as const;

export const ICONS = [
  {
    href: "https://twitter.com/DMMTV_PR",
    iconName: "twitter",
  },
  {
    href: "https://www.youtube.com/channel/UCT4TwZQE6biCATLwQ-kIrFg",
    iconName: "youTube",
  },
  {
    href: "https://www.instagram.com/DMMTV_PR/",
    iconName: "instagram",
  },
  {
    href: "https://www.tiktok.com/@dmmtv_pr",
    iconName: "tikTok",
  },
] as const;
